import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./LeadDatePicker.css";
import { ymdToDate, dateToYmd } from "../ExpenseManagement/ExpenseDatePicker";

const CalendarIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

// Next follow-up date picker — same 'YYYY-MM-DD' in/out contract and portal
// pattern as ExpenseDatePicker (reused directly rather than re-derived),
// needed here for the same reason: LeadDetailDrawer also renders inside a
// SlidePanel, which clips a normally-positioned calendar popper.
//
// `value` may be an old free-text follow-up value some leads still carry
// (e.g. "6 Sep, 9:00 AM", from before this was a date picker) — ymdToDate
// returns null for anything that isn't a real 'YYYY-MM-DD' string, so the
// picker just shows empty rather than erroring on it.
//
// react-datepicker's own input has no visual date-field affordance by
// default (looks like plain text) — the calendar icon here is purely a UI
// cue; clicking it opens the same picker as clicking the input itself, via
// the DatePicker instance's own setOpen() ref API.
function LeadDatePicker({ value, onChange, disabled = false, placeholder = "dd-mmm-yyyy" }) {
  const pickerRef = useRef(null);

  return (
    <div className="leads-datepicker-wrap">
      <DatePicker
        ref={pickerRef}
        selected={ymdToDate(value)}
        onChange={(date) => onChange(dateToYmd(date))}
        dateFormat="dd-MMM-yyyy"
        placeholderText={placeholder}
        isClearable
        disabled={disabled}
        autoComplete="off"
        className="form-control leads-datepicker-input"
        portalId="leads-datepicker-portal"
        popperClassName="leads-datepicker-popper"
        popperProps={{ strategy: "fixed" }}
      />
      <span
        className="leads-datepicker-icon"
        onClick={() => !disabled && pickerRef.current?.setOpen(true)}
        aria-hidden="true"
      >
        <CalendarIcon />
      </span>
    </div>
  );
}

export default LeadDatePicker;
